import * as React from "react";
import moment from "moment";

export const FacesheetLTCReferral = ({ referralDetails, additionalDetails }) => {
    return (
        <div className="facesheet-personal">
            <h4 className="facesheet-personal__name">Referral Details</h4>

            <div className="facesheet-personal__info">
                <div className="facesheet-personal__left">
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Name: </span>
                        <span className="p-regular">
                            {referralDetails?.referralContactDetails?.firstName +
                                " " +
                                referralDetails?.referralContactDetails?.lastName}
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Source: </span>
                        <span className="p-regular">{referralDetails?.referralSource}</span>
                    </div>
                </div>
                <div className="facesheet-personal__right">
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Contact Number </span>
                            <span className="p-regular">{referralDetails?.referralContactDetails?.phoneNumber}</span>
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Facility Name: </span>
                        <span className="p-regular">{referralDetails?.referralFacilityName}</span>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <h4 className="facesheet-personal__name">Additional Contact Details</h4>

            <div className="facesheet-personal__info">
                <div className="facesheet-personal__left">
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Name: </span>
                        <span className="p-regular">
                            {additionalDetails?.firstName + " " + referralDetails?.referralContactDetails?.lastName}
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Relation to patient: </span>
                        <span className="p-regular">{additionalDetails?.relationToPatient}</span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Organizaton Name: </span>
                        <span className="p-regular">{additionalDetails?.organizationName}</span>
                    </div>
                </div>
                <div className="facesheet-personal__right">
                    <div className="facesheet-personal__info-item">
                        <span className="p-regular">
                            <span className="h5">Contact Number </span>
                            <span className="p-regular">{additionalDetails?.phoneNumber}</span>
                        </span>
                    </div>
                    <div className="facesheet-personal__info-item">
                        <span className="h5">Facility Name: </span>
                        <span className="p-regular">{additionalDetails?.organizationName}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
